import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import ArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import AppLogo from "assets/avantor-logo-monotone.png";

const styles = () => ({
  root: {
    display: "flex",
    flexDirection: "column",
  },
  appbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    flexDirection: "row",
    height: 36,
    background: "#236192",
    position: "fixed",
    top: 0,
    padding: "0 24px",
    color: "#d3ebff",
    zIndex: 99,
    lineHeight: 0,
    fontWeight: 500,
    userSelect: "none",
  },
  appLogo: {
    width: 130,
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    flexDirection: "row",
    height: 38,
    background: "#e2e2e2",
    position: "fixed",
    top: 36,
    padding: "0 24px",
    boxShadow: "0 1px 1px #c1c1c1",
    zIndex: 99,
    lineHeight: 0,
    fontWeight: 500,
    userSelect: "none",
  },
  userMenu: {
    display: "flex",
    alignItems: "center",
    lineHeight: 0,
    cursor: "pointer",
  },
  userMenuDropDown: {
    display: "flex",
    position: "absolute",
    top: 36,
    background: "#236192",
    zIndex: "9999",
    right: 27,
    color: "#d3ebff",
    minWidth: 160,
  },
  fullWidth: {
    width: "100%",
  },
});

class AppBar extends React.Component {
  state = {
    isOpen: false,
  };

  handleMenuOpen = () => {
    this.setState({ isOpen: true });
  };

  handleMenuClose = () => {
    this.setState({ isOpen: false });
  };

  handleSignoutAction = () => {
    this.props.signOutAction();
    this.handleMenuClose();
  };

  renderMenu = () => (
    <ClickAwayListener onClickAway={this.handleMenuClose}>
      <List disablePadding={true} classes={{root: this.props.classes.fullWidth}}>
        <ListItem button onClick={this.handleSignoutAction}>
          Sign Out
        </ListItem>
      </List>
    </ClickAwayListener>
  );

  render() {
    const { classes, profile } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.appbar}>
          <div>
            <Link to="/">
              <img className={classes.appLogo} src={AppLogo} alt="avantor" />
            </Link>
          </div>

          <div className={classes.userMenu} onClick={this.handleMenuOpen}>
            <span>{profile.name?profile.name:'Anonymous'}</span>
            <span>
              <ArrowDownIcon />
            </span>
          </div>
        </div>
        <div className={classes.toolbar}>
          <div>Customer Engagement Tool</div>
        </div>
        {this.state.isOpen && (
          <div className={classes.userMenuDropDown}>{this.renderMenu()}</div>
        )}
      </div>
    );
  }
}

AppBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AppBar);
